import React, { useEffect, useState } from 'react';
export function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  useEffect(() => {
    document.title = 'Dr. Stephen P. Griffith MD, JD | Emergency Medicine Physician & Attorney';
  }, []);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <div className="min-h-screen bg-white" data-id="element-0">
      {/* Header/Navigation */}
      <header className="fixed w-full bg-white shadow-md z-50" data-id="element-1">
        <div className="container mx-auto px-4 md:px-6 py-3 md:py-4" data-id="element-2">
          <div className="flex justify-between items-center" data-id="element-3">
            <div className="flex items-center" data-id="element-4">
              <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-[#0a3d62]" data-id="element-5">
                Dr. Stephen P. Griffith{' '}
                <span className="text-[#b8860b] whitespace-nowrap" data-id="element-6">MD, JD</span>
              </h1>
            </div>
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex space-x-4" data-id="element-7">
              <a href="#home" className="nav-link" data-id="element-8">
                Home
              </a>
              <a href="#about" className="nav-link" data-id="element-9">
                About
              </a>
              <a href="#education" className="nav-link" data-id="element-10">
                Education
              </a>
              <a href="#humanitarian" className="nav-link" data-id="element-11">
                Humanitarian Work
              </a>
              <a href="#expertise" className="nav-link" data-id="element-12">
                Expertise
              </a>
              <a href="#contact" className="nav-link" data-id="element-13">
                Contact
              </a>
            </nav>
            {/* Mobile Menu Button */}
            <div className="lg:hidden" data-id="element-14">
              <button onClick={toggleMenu} className="focus:outline-none" data-id="element-15">
                <svg className="h-6 w-6 text-[#0a3d62]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-16">
                  {isMenuOpen ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-17" /> : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-18" />}
                </svg>
              </button>
            </div>
          </div>
          {/* Mobile Menu */}
          <div className={`mobile-menu lg:hidden ${isMenuOpen ? 'active' : ''}`} data-id="element-19">
            <a href="#home" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-20">
              Home
            </a>
            <a href="#about" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-21">
              About
            </a>
            <a href="#education" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-22">
              Education
            </a>
            <a href="#humanitarian" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-23">
              Humanitarian Work
            </a>
            <a href="#expertise" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-24">
              Expertise
            </a>
            <a href="#contact" className="block py-2 px-4 hover:bg-gray-100" onClick={() => setIsMenuOpen(false)} data-id="element-25">
              Contact
            </a>
          </div>
        </div>
      </header>
      {/* Hero Section */}
      <section id="home" className="pt-24 md:pt-0" data-id="element-26">
        <div className="relative h-screen" data-id="element-27">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `linear-gradient(rgba(10, 61, 98, 0.7), rgba(10, 61, 98, 0.7)), url(${encodeURI('https://uploadthingy.s3.us-west-1.amazonaws.com/dN4ckYEGt4Fo5mGpALWybS/RMO_Stephen_Griffith.jpg')})`
        }} data-id="element-28"></div>
          <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white p-6" data-id="element-29">
            <div className="max-w-3xl" data-id="element-30">
              <h1 className="text-4xl md:text-6xl font-bold mb-6" data-id="element-31">
                Dr. Stephen Patrick Griffith
              </h1>
              <h2 className="text-2xl md:text-3xl mb-8" data-id="element-32">
                Emergency Medicine Physician & Attorney
              </h2>
              <p className="text-lg md:text-xl mb-10" data-id="element-33">
                Board Certified Emergency Medicine Specialist with expertise in
                trauma care, disaster relief, and medical law.
              </p>
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 justify-center" data-id="element-34">
                <a href="#about" className="btn-primary" data-id="element-35">
                  Learn More
                </a>
                <a href="#contact" className="btn-primary bg-[#b8860b] hover:bg-[#a67a0b]" data-id="element-36">
                  Contact Dr. Griffith
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section id="about" className="py-20 bg-white" data-id="element-37">
        <div className="container mx-auto px-6" data-id="element-38">
          <div className="flex flex-col md:flex-row items-center" data-id="element-39">
            <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-40">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/uU8zb8h8fKFJxYzi7fMhb9/Griffith_Stephen_MD_photo%282%29.jpg" alt="Dr. Stephen Griffith" className="rounded-lg shadow-xl max-w-full h-auto" data-id="element-41" />
            </div>
            <div className="md:w-1/2 md:pl-12" data-id="element-42">
              <h2 className="section-title text-3xl font-bold text-[#0a3d62]" data-id="element-43">
                About Dr. Griffith
              </h2>
              <p className="mb-6" data-id="element-44">
                Dr. Stephen Patrick Griffith is board certified by the American
                Board of Emergency Medicine with years of experience providing
                medical care in various settings across the globe. His unique
                combination of medical expertise and legal knowledge makes him
                an exceptional professional in both fields.
              </p>
              <p className="mb-6" data-id="element-45">
                With a passion for humanitarian work, Dr. Griffith has
                participated in numerous international relief missions,
                including providing critical trauma care after the devastating
                7.0 earthquake in Port-au-Prince, Haiti. His dedication to
                serving those in need earned him recognition as "Humanitarian of
                the Year" by Space Coast Medicine in 2011.
              </p>
              <p data-id="element-46">
                As an expert in trauma care and emergency preparedness, Dr.
                Griffith regularly lectures on these topics both internationally
                and locally. He remains committed to serving vulnerable
                populations and people in their greatest time of need.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Education & Qualifications Section */}
      <section id="education" className="py-20 bg-gray-50" data-id="element-47">
        <div className="container mx-auto px-6" data-id="element-48">
          <h2 className="section-title text-3xl font-bold text-[#0a3d62] text-center mb-12" data-id="element-49">
            Education & Qualifications
          </h2>
          <div className="timeline max-w-3xl mx-auto" data-id="element-50">
            <div className="timeline-item" data-id="element-51">
              <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-52">
                Juris Doctor (JD)
              </h3>
              <p className="text-gray-600" data-id="element-53">
                Mitchell Hamline College of Law, St. Paul, MN
              </p>
            </div>
            <div className="timeline-item" data-id="element-54">
              <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-55">
                Residency, Emergency Medicine
              </h3>
              <p className="text-gray-600" data-id="element-56">
                Wright State University, Dayton, OH
              </p>
              <p className="text-sm text-gray-500 italic" data-id="element-57">Chief Resident</p>
            </div>
            <div className="timeline-item" data-id="element-58">
              <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-59">
                Doctor of Medicine (MD)
              </h3>
              <p className="text-gray-600" data-id="element-60">
                University of Missouri, Columbia School of Medicine
              </p>
            </div>
            <div className="timeline-item" data-id="element-61">
              <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-62">
                Bachelor's Degree in Biology and Spanish
              </h3>
              <p className="text-gray-600" data-id="element-63">
                Trinity University, San Antonio, TX
              </p>
            </div>
            <div className="timeline-item" data-id="element-64">
              <h3 className="text-xl font-bold text-[#0a3d62]" data-id="element-65">
                Board Certification
              </h3>
              <p className="text-gray-600" data-id="element-66">
                American Board of Emergency Medicine
              </p>
            </div>
          </div>
          <div className="mt-16" data-id="element-67">
            <h3 className="text-2xl font-bold text-[#0a3d62] text-center mb-8" data-id="element-68">
              Professional Memberships
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-69">
              <div className="card bg-white p-6" data-id="element-70">
                <h4 className="font-bold text-lg mb-2" data-id="element-71">
                  American College of Emergency Physicians - International
                </h4>
                <p className="text-gray-600" data-id="element-72">Active Member</p>
              </div>
              <div className="card bg-white p-6" data-id="element-73">
                <h4 className="font-bold text-lg mb-2" data-id="element-74">
                  American Academy of Emergency Medicine
                </h4>
                <p className="text-gray-600" data-id="element-75">Active Member</p>
              </div>
              <div className="card bg-white p-6" data-id="element-76">
                <h4 className="font-bold text-lg mb-2" data-id="element-77">
                  Society for Academic Emergency Medicine
                </h4>
                <p className="text-gray-600" data-id="element-78">Active Member</p>
              </div>
              <div className="card bg-white p-6" data-id="element-79">
                <h4 className="font-bold text-lg mb-2" data-id="element-80">
                  American Medical Association
                </h4>
                <p className="text-gray-600" data-id="element-81">Active Member</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Humanitarian Work Section */}
      <section id="humanitarian" className="py-20 bg-white" data-id="element-82">
        <div className="container mx-auto px-6" data-id="element-83">
          <h2 className="section-title text-3xl font-bold text-[#0a3d62] text-center mb-12" data-id="element-84">
            Humanitarian Work
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-85">
            <div className="card bg-gray-50 overflow-hidden" data-id="element-86">
              <div className="h-48 bg-[#0a3d62] flex items-center justify-center" data-id="element-87">
                <h3 className="text-white text-xl font-bold" data-id="element-88">Haiti</h3>
              </div>
              <div className="p-6" data-id="element-89">
                <p className="mb-4" data-id="element-90">
                  Provided critical trauma care after the 7.0 earthquake in
                  Port-au-Prince, assisting in amputations and emergency
                  procedures at the regional hospital.
                </p>
                <p className="text-sm text-[#b8860b] font-semibold" data-id="element-91">
                  Recognized as "Humanitarian of the Year" by Space Coast
                  Medicine in 2011 for these efforts.
                </p>
              </div>
            </div>
            <div className="card bg-gray-50 overflow-hidden" data-id="element-92">
              <div className="h-48 bg-[#0a3d62] flex items-center justify-center" data-id="element-93">
                <h3 className="text-white text-xl font-bold" data-id="element-94">Africa</h3>
              </div>
              <div className="p-6" data-id="element-95">
                <p data-id="element-96">
                  Participated in medical missions providing essential
                  healthcare services to underserved communities, leveraging his
                  knowledge of Ewe to better communicate with local populations.
                </p>
              </div>
            </div>
            <div className="card bg-gray-50 overflow-hidden" data-id="element-97">
              <div className="h-48 bg-[#0a3d62] flex items-center justify-center" data-id="element-98">
                <h3 className="text-white text-xl font-bold text-center" data-id="element-99">
                  Guatemala & Afghanistan
                </h3>
              </div>
              <div className="p-6" data-id="element-100">
                <p data-id="element-101">
                  Conducted humanitarian medical work in challenging
                  environments, providing emergency care and training local
                  healthcare providers in trauma management techniques.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-16 text-center" data-id="element-102">
            <h3 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-103">
              Disaster Relief & Emergency Preparedness
            </h3>
            <p className="max-w-3xl mx-auto mb-8" data-id="element-104">
              Dr. Griffith is committed to sharing his expertise in disaster
              planning and preparedness through lectures and training sessions
              both internationally and locally. His experience in real-world
              disaster scenarios informs his approach to emergency preparedness
              training.
            </p>
            <div className="flex justify-center" data-id="element-105">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cEorxC5cgJJKfr4CqWjoG8/MedLaw.png" alt="Medical and Legal Symbol" className="h-24 opacity-70" data-id="element-106" />
            </div>
          </div>
        </div>
      </section>
      {/* Expertise Section */}
      <section id="expertise" className="py-20 bg-gray-50" data-id="element-107">
        <div className="container mx-auto px-6" data-id="element-108">
          <h2 className="section-title text-3xl font-bold text-[#0a3d62] text-center mb-12" data-id="element-109">
            Areas of Expertise
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-110">
            <div className="card bg-white p-6" data-id="element-111">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-112">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-113">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-114" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-115">
                Emergency Medicine
              </h3>
              <p className="text-center" data-id="element-116">
                Board-certified specialist with extensive experience in
                emergency departments across various healthcare settings.
              </p>
            </div>
            <div className="card bg-white p-6" data-id="element-117">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-118">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-119">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" data-id="element-120" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-121">
                Trauma Care
              </h3>
              <p className="text-center" data-id="element-122">
                Expert in managing traumatic injuries in both standard emergency
                settings and austere environments during humanitarian missions.
              </p>
            </div>
            <div className="card bg-white p-6" data-id="element-123">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-124">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-125">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" data-id="element-126" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-127">
                Medical Law
              </h3>
              <p className="text-center" data-id="element-128">
                Uniquely qualified with both medical and legal expertise to
                address complex healthcare legal issues and policy matters.
              </p>
            </div>
            <div className="card bg-white p-6" data-id="element-129">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-130">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-131">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" data-id="element-132" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-133">
                Disaster Preparedness
              </h3>
              <p className="text-center" data-id="element-134">
                Provides training and lectures on emergency preparedness,
                drawing from firsthand experience in major disaster zones.
              </p>
            </div>
            <div className="card bg-white p-6" data-id="element-135">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-136">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-137">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" data-id="element-138" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-139">
                Multilingual Care
              </h3>
              <p className="text-center" data-id="element-140">
                Fluent in English and Spanish, with conversational abilities in
                French Creole and Ewe, enabling effective communication with
                diverse patient populations.
              </p>
            </div>
            <div className="card bg-white p-6" data-id="element-141">
              <div className="w-16 h-16 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-6 mx-auto" data-id="element-142">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-143">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" data-id="element-144" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-center mb-4" data-id="element-145">
                Medical Education
              </h3>
              <p className="text-center" data-id="element-146">
                Experienced in training medical professionals and sharing
                knowledge through lectures and presentations on emergency
                medicine and disaster response.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Personal Interests Section */}
      <section className="py-20 bg-white" data-id="element-147">
        <div className="container mx-auto px-6" data-id="element-148">
          <h2 className="section-title text-3xl font-bold text-[#0a3d62] text-center mb-12" data-id="element-149">
            Personal Interests
          </h2>
          <div className="flex flex-wrap justify-center gap-8" data-id="element-150">
            <div className="w-full md:w-1/4 text-center" data-id="element-151">
              <div className="w-20 h-20 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-4 mx-auto" data-id="element-152">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-153">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" data-id="element-154" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-155">General Aviation</h3>
              <p data-id="element-156">Passionate about flying and exploring the skies.</p>
            </div>
            <div className="w-full md:w-1/4 text-center" data-id="element-157">
              <div className="w-20 h-20 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-4 mx-auto" data-id="element-158">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-159">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" data-id="element-160" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-161">Scuba Diving</h3>
              <p data-id="element-162">Exploring underwater worlds and marine environments.</p>
            </div>
            <div className="w-full md:w-1/4 text-center" data-id="element-163">
              <div className="w-20 h-20 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mb-4 mx-auto" data-id="element-164">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-165">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-166" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-167">Traveling</h3>
              <p data-id="element-168">
                Experiencing diverse cultures and communities around the world.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="py-20 bg-gray-50" data-id="element-169">
        <div className="container mx-auto px-6" data-id="element-170">
          <h2 className="section-title text-3xl font-bold text-[#0a3d62] text-center mb-12" data-id="element-171">
            Contact Dr. Griffith
          </h2>
          <div className="flex flex-col md:flex-row gap-10" data-id="element-172">
            <div className="md:w-1/2" data-id="element-173">
              <h3 className="text-2xl font-bold text-[#0a3d62] mb-6" data-id="element-174">
                Get In Touch
              </h3>
              {/*<div className="contact-info-item">
               <div className="w-12 h-12 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mr-4">
               <svg
               xmlns="http://www.w3.org/2000/svg"
               className="h-6 w-6"
               fill="none"
               viewBox="0 0 24 24"
               stroke="currentColor"
               >
               <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
               />
               </svg>
               </div>
               <div>
               <h4 className="font-bold">Phone</h4>
               <p>(555) 123-4567</p>
               </div>
               </div>*/}
              <div className="contact-info-item" data-id="element-175">
                <div className="w-12 h-12 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mr-4" data-id="element-176">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-177">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" data-id="element-178" />
                  </svg>
                </div>
                <div data-id="element-179">
                  <h4 className="font-bold" data-id="element-180">Email</h4>
                  <p data-id="element-181">steve.griffith@themdjd.org</p>
                </div>
              </div>
              {/* <div className="contact-info-item">
               <div className="w-12 h-12 rounded-full bg-[#0a3d62] text-white flex items-center justify-center mr-4">
               <svg
               xmlns="http://www.w3.org/2000/svg"
               className="h-6 w-6"
               fill="none"
               viewBox="0 0 24 24"
               stroke="currentColor"
               >
               <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
               />
               <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
               />
               </svg>
               </div>
               <div>
               <h4 className="font-bold">Office Address</h4>
               <p>
               123 Medical Center Drive, Suite 456
               <br />
               Anytown, USA 12345
               </p>
               </div>
               </div>*/}
            </div>
            <div className="md:w-1/2" data-id="element-182">
              <form className="bg-white p-8 rounded-lg shadow-md" action="https://formsubmit.co/steve.griffith@themdjd.org" method="POST" data-id="element-183">
                <div className="mb-6" data-id="element-184">
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-185">
                    Your Name
                  </label>
                  <input type="text" id="name" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a3d62]" data-id="element-186" />
                </div>
                <div className="mb-6" data-id="element-187">
                  <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-188">
                    Your Email
                  </label>
                  <input type="email" id="email" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a3d62]" data-id="element-189" />
                </div>
                <div className="mb-6" data-id="element-190">
                  <label htmlFor="subject" className="block text-gray-700 font-medium mb-2" data-id="element-191">
                    Subject
                  </label>
                  <input type="text" id="subject" required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a3d62]" data-id="element-192" />
                </div>
                <div className="mb-6" data-id="element-193">
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-2" data-id="element-194">
                    Message
                  </label>
                  <textarea id="message" rows={5} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a3d62]" data-id="element-195"></textarea>
                </div>
                <button type="submit" className="btn-primary w-full" data-id="element-196">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer className="bg-[#0a3d62] text-white py-10" data-id="element-197">
        <div className="container mx-auto px-6" data-id="element-198">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-199">
            <div className="mb-6 md:mb-0" data-id="element-200">
              <h2 className="text-2xl font-bold" data-id="element-201">
                Dr. Stephen P. Griffith{' '}
                <span className="text-[#b8860b]" data-id="element-202">MD, JD</span>
              </h2>
              <p className="mt-2" data-id="element-203">
                Board Certified Emergency Medicine Physician & Attorney
              </p>
            </div>
            {/*<div className="flex space-x-4">
             <a
             href="#"
             className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
             >
             <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-linkedin"
              viewBox="0 0 16 16"
             >
              <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
             </svg>
             </a>
             <a
             href="#"
             className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
             >
             <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-twitter-x"
              viewBox="0 0 16 16"
             >
              <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865l8.875 11.633Z" />
             </svg>
             </a>
             <a
             href="#"
             className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
             >
             <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              className="bi bi-facebook"
              viewBox="0 0 16 16"
             >
              <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
             </svg>
             </a>
             </div>*/}
          </div>
          <hr className="border-white/20 my-8" data-id="element-204" />
          <div className="text-center text-sm" data-id="element-205">
            <p data-id="element-206">
              &copy; {new Date().getFullYear()} Dr. Stephen Patrick Griffith.
              All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}